import React, { useState } from 'react';
import { DatePickerModal, Flex, styled } from '@fareye/ui'
import { yyyyMmDd, startCase, FaCheck, transform  } from '@fareye/utils'
import { IDateRange } from '@fareye/types'
import { Span } from '@fareye/ui';
import DropDown from './filterComponents/DropDown';

const getFilterComponent = (component: string, props: any): React.ReactNode => {
  const { filterType, filterKey, filterValue, setFilterValue, upsertSelectedFilters, toggleActiveFilter} = props
  
  switch (component) {
    case 'dateRange':
      const {additionalDays = 0} = props
      let maxDate = new Date()
      maxDate.setDate(maxDate.getDate() + additionalDays)
      return (
        <DatePickerModal
          value={filterValue}
          variant="fareyeV2"
          formatter={yyyyMmDd}
          onDateRangeSelected={
            (dates: IDateRange<string | Date>) => {
              setFilterValue(dates)
              upsertSelectedFilters(filterType, filterKey, dates)
            } 
          }
          toggleModal = {() => toggleActiveFilter(filterKey)}
          maxDate = {maxDate}
          color={"#EE5239"}
        />
      )
    case 'dropDown':
    default:
      const { summaryData } = props
      const options = summaryData?.[filterKey]?.aggregations || []
      return (
        <DropDown 
          options = {options}
          filterKey = {filterKey}
          filterValue = {filterValue}
          setFilterValue = {setFilterValue}
        />
      )
  }
};

export default getFilterComponent